export default "__VITE_PUBLIC_ASSET__fbf2cded__"